export const SUBDOMAIN_REGEXP = /^[a-z0-9-_\-]+$/
export const SUBDOMAIN_CHAR_LIMIT = 32
export const INVALID_SYMBOLS_MESSAGE =
  'Subdomain can only contain a-z, 0-9, and (_-)'
export const EMPTY_SUBDOMAIN_MESSAGE = 'This filed cannot be empty'
export const LONG_SUBDOMAIN_MESSAGE = 'Subdomain must not exceed 32 characters'
export const RENDERFOREST_SITES = '.renderforestsites.com'
